import * as React from 'react'
import { SVGProps } from 'react'

const SvgTieClips = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      d="M19.437 11.754H2.19a1.128 1.128 0 0 1-1.127-1.127A1.034 1.034 0 0 1 2.19 9.5a23.319 23.319 0 0 1 4.03.71 33.987 33.987 0 0 0 7 1.092c4.125 0 4.244-1.771 4.244-1.973a.511.511 0 0 0-.5-.514.488.488 0 0 0-.5.485c-.037.279-.691 1-3.245 1a33.324 33.324 0 0 1-6.778-1.065A23.164 23.164 0 0 0 2.19 8.5a2.013 2.013 0 0 0-2.127 2.127 2.129 2.129 0 0 0 2.127 2.127h17.247a.5.5 0 0 0 0-1Z"
      fill="#231f20"
    />
  </svg>
)

export default SvgTieClips
